import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

const AthletesList = () => {
  const [athletes, setAthletes] = useState([]);
  const [error, setError] = useState(null);
  const [aClass, setAClass] = useState([])
  const [bClass, setBClass] = useState([])
  const [novice, setNovice] = useState([])
  const [mensMasters, setMensMasters] = useState([])
  const [womensMasters, setWomensMasters] = useState([])
  const [lightweight, setLightweight] = useState([]);
  const [uncategorized, setUncategorized] = useState();
  const [loading, setLoading] = useState(false)

  const fetchDataUrl = "https://cocmgbknd-43a11ed50cba.herokuapp.com/athletics";

useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(fetchDataUrl, { cache: "no-store" });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      setAthletes(data);
      groupAthletes(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);

  if (error) return <div>Error: {error}</div>;
  if (loading) return <div>...Data Loading</div>

  function groupAthletes(athletesList) {
    const a = [];
    const b = [];
    const noviceList = [];
    const mens = [];
    const womens = [];
    const lightweight = [];
    const uncategorizedList = [];
  
    athletesList.forEach(athlete => {
      switch (athlete.className) {
        case "A Class":
          a.push(athlete);
          break;
        case "B Class":
          b.push(athlete);
          break;
        case "Novice":
          noviceList.push(athlete);
          break;
        case "Mens Masters":
          mens.push(athlete);
          break;
        case "Womens":
          womens.push(athlete);
          break;
        case "lightweight":
          lightweight.push(athlete);
          break;
        default:
          uncategorizedList.push(athlete);
          break;
      }
    });
  
    setAClass(a);
    setBClass(b);
    setNovice(noviceList);
    setMensMasters(mens);
    setWomensMasters(womens);
    setLightweight(lightweight)
    setUncategorized(uncategorizedList);
  }
  
  return (
    <Container>
      <Row>
        <h2>Registered Athletes</h2>
        <Table bordered responsive="sm">
        <thead>
        <tr>
          <th>A Class</th>
          <th>B Class</th>
          <th>Novice</th>
          <th>Mens Masters</th>
          <th>Womens Open</th>
          <th>Lightweight</th>
        </tr>
      </thead>
          <tbody>
          <tr>
            <td>
              {aClass.map(athlete => (
                <div key={athlete.name}>{athlete.name}</div>
              ))}
            </td>
            <td>
              {bClass.map(athlete => (
                <div key={athlete.name}>{athlete.name}</div>
              ))}
            </td>
            <td>
              {novice.map(athlete => (
                <div key={athlete.name}>{athlete.name}</div>
              ))}
            </td>
            <td>
              {mensMasters.map(athlete => (
                <div key={athlete.name}>{athlete.name}</div>
              ))}
            </td>
            <td>
              {womensMasters.map(athlete => (
                <div key={athlete.name}>{athlete.name}</div>
              ))}
            </td>
            <td>
              {lightweight.map(athlete => (
                <div key={athlete.name}>{athlete.name}</div>
              ))}
            </td>
          </tr>
          </tbody>
        </Table>
        <small>*Registration fee of $25 due when you check in for the games on game day*</small>
      </Row>
    </Container>
  );
};

export default AthletesList;
